
export const Data=[
  {
    "question": "Who discovered Penicillin?",
    "answers":[
        {
            "text": "Alexander Flemming",
            "correct": true
        },{
            "text": "Alfred Nobel",
            "correct": false
        },{
            "text": "Louis Pasteur",
            "correct": false
        },{
            "text": "Marie Curie",
            "correct": false
        }
    ],
      "correct_answer": "Alexander Flemming",
      "incorrect_answers": [
        "Marie Curie",
        "Alfred Nobel",
        "Louis Pasteur"
      ]
  },
  {
    "question": "Which of the following African countries was most successful in resisting colonization?",
    "answers":[
        {
            "text": "C&ocirc;te d&rsquo;Ivoire",
            "correct": false
        },{
            "text": "Congo",
            "correct": false
        },{
            "text": "Ethiopia",
            "correct": true
        },{
            "text": "Namibia",
            "correct": false
        }
    ],
    "correct_answer": "Ethiopia",
      "incorrect_answers": [
        "C&ocirc;te d&rsquo;Ivoire",
        "Congo",
        "Namibia"
      ]
  },
  {
    "question": "Which of these countries remained neutral during World War II?",
    "correct_answer": "Switzerland",
    "incorrect_answers": [
      "United Kingdom",
      "France",
      "Italy"
    ],
    "answers":[
        {
            "text": "United Kingdom",
            "correct": false
        },{
            "text": "France",
            "correct": false
        },{
            "text": "Italy",
            "correct": false
        },{
            "text": "Switzerland",
            "correct": true
        }
    ],
  },
  {
    "question": "In which year did the Invasion of Kuwait by Iraq occur?",
    "answers":[
        {
            "text": "1992",
            "correct": false
        },{
            "text": "1990",
            "correct": true
        },{
            "text": "1988",
            "correct": false
        },{
            "text": "1986",
            "correct": false
        }
    ],
    "correct_answer": "1990",
      "incorrect_answers": [
        "1992",
        "1988",
        "1986"
      ]
  },
  {
    "question": "When did the Battle of the Somme begin?",
    "answers":[
        {
            "text": "August 1st, 1916",
            "correct": false
        },{
            "text": "July 2nd, 1916",
            "correct": false
        },{
            "text": "July 1st, 1916",
            "correct": true
        },{
            "text": "June 30th, 1916",
            "correct": false
        }
    ],
    "correct_answer": "July 1st, 1916",
      "incorrect_answers": [
        "August 1st, 1916",
        "July 2nd, 1916",
        "June 30th, 1916"
      ]
  },
  {
    "question": "In 1720, England was in massive debt, and became in involved in the South Sea Bubble. Who was the main mastermind behind it?",
    "answers":[
        {
            "text": "John Blunt",
            "correct": true
        },{
            "text": "Daniel Defoe",
            "correct": false
        },{
            "text": "Robert Harley",
            "correct": true
        },{
            "text": "John Churchill",
            "correct": false
        }
    ],
    "correct_answer": "John Blunt",
      "incorrect_answers": [
        "Daniel Defoe",
        "Robert Harley",
        "John Churchill"
      ]
  },
  {
    "question": "Who was the Prime Minister of Japan when Japan declared war on the US?",
    "answers":[
        {
            "text": "Hideki Tojo",
            "correct": true
        },{
            "text": "Michinomiya Hirohito",
            "correct": false
        },{
            "text": "Isoroku Yamamoto",
            "correct": true
        },{
            "text": "Fumimaro Konoe",
            "correct": false
        }
    ],
    "correct_answer": "Hideki Tojo",
      "incorrect_answers": [
        "Michinomiya Hirohito",
        "Isoroku Yamamoto",
        "Fumimaro Konoe"
      ]
  },
  {
    "question": "How was Socrates executed?",
    "correct_answer": "Poison",
    "incorrect_answers": [
      "Decapitation",
      "Firing squad",
      "Crucifixion "
    ],
    "answers":[
        {
            "text": "Decapitation",
            "correct": false
        },{
            "text": "Firing squad",
            "correct": false
        },{
            "text": "Poison",
            "correct": true
        },{
            "text": "Crucifixion",
            "correct": false
        }
    ],
  },
  {
    "question": "What year did World War I begin?",
    "answers":[
        {
            "text": "1914",
            "correct": true
        },{
            "text": "1905",
            "correct": false
        },{
            "text": "1919",
            "correct": false
        },{
            "text": "1925",
            "correct": false
        }
    ],
    "correct_answer": "1914",
      "incorrect_answers": [
        "1905",
        "1919",
        "1925"
      ]
  },
  {
    "question": "Which modern country is known as &quot;The Graveyard of Empires&quot;?",
    "correct_answer": "Afghanistan",
    "incorrect_answers": [
      "China",
      "Iraq",
      "Russia"
    ],
    "answers":[
        {
            "text": "China",
            "correct": false
        },{
            "text": "Iraq",
            "correct": false
        },{
            "text": "Russia",
            "correct": false
        },{
            "text": "Afghanistan",
            "correct": true
        }
    ],
  },
  {
    "question": "In 1453, which important city fell?",
    "correct_answer": "Constantinople",
    "incorrect_answers": [
      "Rome",
      "Hamburg",
      "Athens"
    ],
    "answers":[
        {
            "text": "Constantinople",
            "correct": true
        },{
            "text": "Rome",
            "correct": false
        },{
            "text": "Hamburg",
            "correct": false
        },{
            "text": "Athens",
            "correct": false
        }
    ],
  },
  {
    "question": "On what street did the 1666 Great Fire of London start?",
    "correct_answer": "Pudding Lane",
    "incorrect_answers": [
      "Baker Street",
      "Houses of Parliament",
      "St Paul&#039;s Cathedral"
    ]
    ,
    "answers":[
        {
            "text": "Baker Street",
            "correct": false
        },{
            "text": "Houses of Parliament",
            "correct": false
        },{
            "text": "Pudding Lane",
            "correct": true
        },{
            "text": "St Paul&#039;s Cathedral",
            "correct": false
        }
    ],
  },
  {
    "question": "What does the United States of America celebrate during the 4th of July?",
    "correct_answer": "The signing of the Declaration of Independence",
    "incorrect_answers": [
      "The anniversary of the Battle of Gettysburg",
      "The crossing of the Delaware River",
      "The ratification of the Constitution"
    ],
    "answers":[
        {
            "text": "The signing of the Declaration of Independence",
            "correct": true
        },{
            "text": "The anniversary of the Battle of Gettysburg",
            "correct": false
        },{
            "text": "The crossing of the Delaware River",
            "correct": false
        },{
            "text": "The ratification of the Constitution",
            "correct": false
        }
    ],
  },
  {
    "question": "Who was the first American in space?",
    "correct_answer": "Alan Shephard",
    "incorrect_answers": [
      "Neil Armstrong",
      "John Glenn",
      "Jim Lovell"
    ],
    "answers":[
        {
            "text": "Neil Armstrong",
            "correct": false
        },{
            "text": "John Glenn",
            "correct": false
        },{
            "text": "Jim Lovell",
            "correct": false
        },{
            "text": "Alan Shephard",
            "correct": true
        }
    ],
  }
];

